function getURLVar(key) {
  var value = [];
  var query = String(document.location).split('?');
  if (query[1]) {
    var part = query[1].split('&');
    for (var i = 0; i < part.length; i++) {
      var data = part[i].split('=');
      if (data[0] && data[1]) {
        value[data[0]] = data[1];
      }
    }
    if (value[key]) {
      return value[key];
    } else {
      return '';
    }
  }
  return '';
}

function isEmpty(el){
  return !$.trim(el.html());
}

$(document).ajaxStop(function() {
  if (!isEmpty($('#product'))) {
    $('#product .option-container').addClass('has-option');
  }
});

// resize code for equal size grids and content start
var img_ratio = 2.0/3.0;


$(document).ready(function() {

  /* =========================================================
     AFB — CART FAST SYNC (anti-cache + retry leve)
     - evita /cart.js cacheando e mostrando carrinho vazio
     - garante que load(cart) receba o carrinho já atualizado
  ========================================================= */
  function AFB_readCartCount(){
    try{
      var t = ($('#cart > button #cart-total').text() || '').trim();
      var n = parseInt(t, 10);
      return isNaN(n) ? 0 : n;
    }catch(e){ return 0; }
  }

  function AFB_fetchCartFresh(){
    // fetch mais rápido e com no-store; cai pra jQuery se não tiver
    var url = '/cart.js?ts=' + Date.now();
    if (window.fetch) {
      return fetch(url, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'Accept': 'application/json' }
      }).then(function(r){ return r.json(); });
    }
    return new Promise(function(resolve, reject){
      if (!window.jQuery) return reject(new Error('no_jquery'));
      jQuery.getJSON(url, resolve).fail(reject);
    });
  }

  function AFB_waitCartUpdate(prevCount, maxWaitMs){
    prevCount = Number(prevCount || 0);
    maxWaitMs = Number(maxWaitMs || 1400);
    var start = Date.now();

    function step(){
      return AFB_fetchCartFresh().then(function(cart){
        var c = (cart && typeof cart.item_count === 'number') ? cart.item_count : null;
        // se mudou ou se o carrinho já tem itens (e antes era 0), podemos seguir
        if (c != null && c !== prevCount) return cart;

        if ((Date.now() - start) >= maxWaitMs) return cart;

        return new Promise(function(res){
          setTimeout(function(){ res(step()); }, 140);
        });
      });
    }
    return step();
  }


  $('.shopify-currency-form select').on('change', function() {
    $(this).parents('form').submit();
  });

  

  // sidebar mobile toggle code start
  if ($(window).width() <=991 ) {

    $('#sidebar-toggle .oc-menu-bar').click(function (e) {
      e.stopPropagation();
      var effect = $(this).closest('#sidebar-toggle.oc-menu').find('.menu-effect').val();
      $('#column-left').addClass('sidebar-toggle');
      $('.sidebar-overlay').toggle();

      if(effect == "none")  { $('#column-left').toggle(); }
      if(effect == "fade")  { $('#column-left').fadeToggle(); }
      if(effect == "slide") { $('#column-left').slideToggle(); }
    });

    $('#column-left').click(function(e){
      e.stopPropagation();
    });

    $(document.body).click(function(e){
      var effect = $('#sidebar-toggle.oc-menu').find('.menu-effect').val();
      $('.sidebar-overlay').hide();
      if(effect == "none")  { $('#column-left').hide(); }
      if(effect == "fade")  { $('#column-left').fadeOut(); }
      if(effect == "slide") { $('#column-left').slideUp(); }
    });
  }
  // sidebar mobile toggle code end

  // Adding active class for mobtabs on mobile layout
  $('.mobtab a').click(function(e){
    $('.mobtab a').removeClass('active');
    $(this).addClass('active');
  });

  // product video
  $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

  // color swatch js snippet
  $('.swatch :radio').change(function() {
    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
    var optionValue = $(this).val();
    $(this).closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
  });

/* =========================================================
   AFB — TOAST + FINALIZAR COMPRA (YEVER) + BRINDE (BLINDADO)
   - Troca Funko pago -> Funko BRINDE antes de chamar Yever
   - Wrap seguro do endShopping (Yever)
   - Botão do toast chama apenas endShopping (já wrapado)
========================================================= */

(function () {

  /* =========================
     HELPERS
  ========================= */
  async function getJSON(url){
    const r = await fetch(url, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });
    if (!r.ok) throw new Error(`GET ${url} -> ${r.status}`);
    return r.json();
  }

  async function postForm(url, dataObj){
    const body = new URLSearchParams();
    Object.keys(dataObj).forEach(k => body.set(k, dataObj[k]));
    const r = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body
    });
    if (!r.ok) throw new Error(`POST ${url} -> ${r.status}`);
    return r.json().catch(()=> ({}));
  }

  function isFunkoItem(item){
    const v = (item.vendor || '').toLowerCase();
    const t = (item.product_title || item.title || '').toLowerCase();
    return v.includes('funko') || t.includes('funko');
  }

  function isBrindeItem(item){
    const h = (item.handle || '').toLowerCase();
    const t = (item.product_title || item.title || '').toLowerCase();
    return h.endsWith('-brinde') || t.includes(' brinde');
  }

  async function getBrindeVariantIdFromHandle(originalHandle){
    const base = (originalHandle || '').toLowerCase();
    const brindeHandle = base.endsWith('-brinde') ? base : (base + '-brinde');

    // ⚠️ precisa estar publicado no canal "Loja virtual" para responder
    const p = await getJSON(`/products/${encodeURIComponent(brindeHandle)}.js`);
    if (!p?.variants?.length) throw new Error('Produto BRINDE sem variants / não publicado');

    return p.variants[0].id;
  }

  /* =========================
     AFB_prepareCartForYever (GLOBAL)
  ========================= */
  window.AFB_prepareCartForYever = async function(){
    // trava contra repetição (clique duplo / wrap + botão)
    const now  = Date.now();
    const last = Number(sessionStorage.getItem('afb_y_prepare_ts') || 0);
    if (now - last < 4000) return; // 4s proteção
    sessionStorage.setItem('afb_y_prepare_ts', String(now));

    const cart = await getJSON('/cart.js');
    if (!cart?.items?.length) return;

    for (const item of cart.items) {
      try {
        if (!isFunkoItem(item)) continue;
        if (isBrindeItem(item)) continue;

        const qty = item.quantity || 1;
        const originalHandle = item.handle;
        const originalKey    = item.key; // line-item key do cart.js

        if (!originalHandle || !originalKey) continue;

        // 1) acha variant do BRINDE
        const brindeVariantId = await getBrindeVariantIdFromHandle(originalHandle);

        // 2) adiciona o BRINDE
        await postForm('/cart/add.js', { id: brindeVariantId, quantity: qty });

        // 3) remove o Funko pago
        await postForm('/cart/change.js', { id: originalKey, quantity: 0 });

      } catch (err) {
        console.warn('[AFB_prepareCartForYever] falhou para:', item?.title, err);
        // não quebra o fluxo inteiro
      }
    }
  };

  /* =========================
     WRAP do endShopping (Yever)
     - Um único ponto de verdade
  ========================= */
  function wrapEndShoppingWhenReady(){
    if (typeof window.endShopping !== 'function') return false;
    if (window.endShopping.__AFB_WRAPPED__) return true;

    const original = window.endShopping;

    window.endShopping = async function(ev){
      try { if (ev?.preventDefault) ev.preventDefault(); } catch(_){}

      try{
        if (typeof window.AFB_prepareCartForYever === 'function') {
          await window.AFB_prepareCartForYever();
        }
      } catch (err){
        console.error('[AFB] erro preparando carrinho antes da Yever:', err);
        // mesmo com erro, segue pro checkout pra não travar usuário
      }

      return original.call(this, ev);
    };

    window.endShopping.__AFB_WRAPPED__ = true;
    return true;
  }

  // tenta agora e também mais tarde (caso Yever carregue depois)
  let tries = 0;
  const iv = setInterval(function(){
    tries++;
    if (wrapEndShoppingWhenReady() || tries > 80) clearInterval(iv); // ~20s
  }, 250);

  /* =========================
     CLICK do botão "Finalizar compra" do TOAST
     - não chama prepare aqui
     - só chama endShopping (já wrapado)
  ========================= */
  document.addEventListener('click', function(e){
    const btn = e.target.closest('#afbToastCheckout');
    if (!btn) return;

    e.preventDefault();

    // anti duplo clique
    if (btn.dataset.loading === '1') return;
    btn.dataset.loading = '1';

    try { btn.disabled = true; } catch(_){}

    try{
      if (typeof window.endShopping === 'function') {
        window.endShopping(); // já prepara antes (wrap)
      } else {
        // se ainda não carregou, manda pro carrinho (Yever roda forte lá)
        window.location.href = '/cart';
      }
    } catch (err){
      console.error('[AFB] clique toast checkout falhou:', err);
      window.location.href = '/cart';
    } finally {
      setTimeout(function(){
        try { btn.disabled = false; } catch(_){}
        btn.dataset.loading = '0';
      }, 5000);
    }
  });

})();

/* =========================================================
   AFB — ADD TO CART HUD (substitui toastr)
========================================================= */
window.AFB_AddToCartToast = (function(){
  var root, timer, styled = false;

  function ensureStyles(){
    if (styled) return;
    styled = true;

    try{
      var css = ""
        + "#afbAddToast .afb-addtoast__bar{ overflow:hidden; }"
        + "#afbAddToast .afb-addtoast__bar i{ display:block; width:100%; height:100%; transform-origin:left center; transform:scaleX(0); will-change:transform; }";
      var st = document.createElement('style');
      st.id = 'afbAddToastSmoothBar';
      st.appendChild(document.createTextNode(css));
      document.head.appendChild(st);
    }catch(e){}
  }

  function ensure(){
    if (root) return root;

    ensureStyles();

    root = document.createElement('div');
    root.id = 'afbAddToast';
    root.className = 'is-hidden';

    root.innerHTML =
      "<div class='afb-addtoast__inner'>" +
        "<div class='afb-addtoast__row'>" +
          "<div class='afb-addtoast__icon' aria-hidden='true'>✓</div>" +
          "<div>" +
            "<div class='afb-addtoast__title'>Item adicionado ao carrinho!</div>" +
            "<div class='afb-addtoast__sub'>Pronto pra finalizar? 😄</div>" +
          "</div>" +
          "<div class='afb-addtoast__spacer'></div>" +
          "<button type='button' class='afb-addtoast__close' aria-label='Fechar'>×</button>" +
        "</div>" +

        "<div class='afb-addtoast__actions'>" +
          "<a class='afb-addtoast__btn' href='/cart'>Ver carrinho</a>" +
          "<button type='button' class='afb-addtoast__btn is-primary' id='afbToastCheckout'>" +
            "Finalizar compra" +
          "</button>" +
        "</div>" +

        "<div class='afb-addtoast__bar' aria-hidden='true'><i></i></div>" +
      "</div>";

    document.body.appendChild(root);

    var closeBtn = root.querySelector('.afb-addtoast__close');
    if (closeBtn) closeBtn.addEventListener('click', hide);

    root.addEventListener('mouseenter', function(){
      if (timer) clearTimeout(timer);
    });
    root.addEventListener('mouseleave', function(){
      timer = setTimeout(hide, 2200);
    });

    return root;
  }

  function pulseCart(){
    var el =
      document.querySelector('#cart > button') ||
      document.querySelector('#cart button') ||
      document.querySelector('#cart');

    if (!el) return;

    if (!el.id) el.id = 'afbCartPulseTarget';
    el.classList.remove('afb-cart-bump');
    void el.offsetWidth;
    el.classList.add('afb-cart-bump');

    setTimeout(function(){
      el.classList.remove('afb-cart-bump');
    }, 520);
  }

  function isFunkoCartItem(item){
    var v = String(item.vendor || "").toLowerCase();
    var t = String(item.product_type || "").toLowerCase();
    var title = String(item.product_title || item.title || "").toLowerCase();
    var handle = String(item.handle || "").toLowerCase();
    return (
      v.indexOf("funko") !== -1 ||
      t.indexOf("funko") !== -1 ||
      title.indexOf("funko") !== -1 ||
      handle.indexOf("funko") !== -1
    );
  }

  function computeCartMeta(cart){
    var funkoQty = 0;
    var nonFunkoQty = 0;
    var nonFunkoTotalCents = 0;

    var items = (cart && cart.items) ? cart.items : [];
    for (var i=0;i<items.length;i++){
      var it = items[i] || {};
      var q = Number(it.quantity || 0);

      // Shopify cart.js costuma ter final_line_price / line_price (cents)
      var line = 0;
      if (it.final_line_price != null) line = Number(it.final_line_price || 0);
      else if (it.line_price != null) line = Number(it.line_price || 0);
      else line = Number(it.price || 0) * q;

      if (isFunkoCartItem(it)) funkoQty += q;
      else {
        nonFunkoQty += q;
        nonFunkoTotalCents += line;
      }
    }

    var funkoRuleApplies = (funkoQty > 0 && nonFunkoQty === 0); // MODE only_funko
    return {
      funkoQty: funkoQty,
      nonFunkoQty: nonFunkoQty,
      nonFunkoTotalCents: nonFunkoTotalCents,
      funkoRuleApplies: funkoRuleApplies
    };
  }

  function startSmoothBar(el, dur){
    var bar = el.querySelector('.afb-addtoast__bar i');
    if (!bar) return;

    // reset
    bar.style.transition = 'none';
    bar.style.transform = 'scaleX(0)';
    bar.getBoundingClientRect(); // reflow

    // animate
    bar.style.transition = 'transform ' + dur + 'ms linear';
    requestAnimationFrame(function(){
      bar.style.transform = 'scaleX(1)';
    });
  }

  function show(opts){
    opts = opts || {};

    var MIN_FUNKO = 5;
    var GOLD_MIN_CENTS = 200000; // R$ 2.000

    // 🚫 se o box de Funko estiver visível, não mostrar toast padrão
    var funkoBox = document.getElementById('afbFunkoMinBox');
    if (funkoBox && funkoBox.offsetParent !== null) return;

    // precisa dos helpers (injetados no document.ready)
    if (typeof AFB_waitCartUpdate !== "function" || typeof AFB_readCartCount !== "function") return;

    var prevCount = AFB_readCartCount();

    AFB_waitCartUpdate(prevCount, 1400).then(function(cart){
      if (!cart || !cart.items) return;

      var meta = computeCartMeta(cart);

      // 🎯 Regra 1 — carrinho só Funko → precisa ter 5
      // 🎯 Regra 2 — carrinho normal → precisa bater 2000 (não-Funko)
      var shouldShow = meta.funkoRuleApplies
        ? (Number(meta.funkoQty || 0) >= MIN_FUNKO)
        : (Number(meta.nonFunkoTotalCents || 0) >= GOLD_MIN_CENTS);

      if (!shouldShow) return;

      var el = ensure();
      el.classList.remove('is-hidden');
      el.classList.add('is-show');

      var title = el.querySelector('.afb-addtoast__title');
      var sub   = el.querySelector('.afb-addtoast__sub');

      if (title) title.textContent = opts.title || "Meta atingida! 🎉";
      if (sub)   sub.textContent   = opts.sub   || "Agora você pode finalizar ✨";

      var dur = Number(opts.dur || 4200);
      el.style.setProperty('--dur', dur + 'ms');

      startSmoothBar(el, dur);
      pulseCart();

      if (timer) clearTimeout(timer);
      timer = setTimeout(hide, dur);
    }).catch(function(){});
  }

  function hide(){
    if (!root) return;
    root.classList.remove('is-show');
    setTimeout(function(){
      root.classList.add('is-hidden');
    }, 220);
  }

  return { show: show, hide: hide };
})();

/* =========================================================
   AFB — CHECKOUT ROUTER (sempre Yever, fallback /cart)
========================================================= */
window.AFB_goCheckout = function(){
  try{
    if (typeof window.endShopping === 'function') {
      window.endShopping(); // já está WRAPADO (vai preparar carrinho antes)
      return;
    }
  }catch(e){}

  // fallback seguro: no /cart o script da Yever costuma interceptar
  window.location.href = '/cart';
};

/* =========================================================
   AFB — FORÇA "Ir para checkout" do afbFunkoMinBox -> Yever
   (captura antes de outros scripts)
========================================================= */
document.addEventListener('click', function(e){
  var box = e.target && e.target.closest ? e.target.closest('#afbFunkoMinBox') : null;
  if (!box) return;

  // pega o elemento clicável mais provável dentro do box
  var target = (e.target && e.target.closest) ? e.target.closest('a,button') : null;
  if (!target) return;

  // 1) seletores diretos (se existirem)
  var btn =
    (target.closest && target.closest('#afbFunkoGoCheckout')) ||
    (target.closest && target.closest('[data-afb-go-checkout]')) ||
    (target.closest && target.closest('a[href="/checkout"], a[href^="/checkout?"], a[href*="/checkouts"]')) ||
    (target.closest && target.closest('button[data-go="checkout"], button.afb-go-checkout'));

  // 2) fallback por texto (garante mesmo se mudar HTML)
  if (!btn){
    var txt = (target.textContent || '').toLowerCase();
    if (txt.indexOf('checkout') !== -1 || txt.indexOf('finalizar') !== -1 || txt.indexOf('pagamento') !== -1){
      btn = target;
    }
  }

  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();
  if (e.stopImmediatePropagation) e.stopImmediatePropagation();

  window.AFB_goCheckout();
}, true);


/* =========================================================
   AFB — FORÇA "Ir para checkout" do afbFunkoMinBox -> Yever
========================================================= */
document.addEventListener('click', function(e){
  // pega cliques dentro do box
  var box = e.target && e.target.closest ? e.target.closest('#afbFunkoMinBox') : null;
  if (!box) return;

  // Tente detectar o botão/link de checkout do box
  var btn =
    e.target.closest('#afbFunkoGoCheckout') ||                       // (ideal se você colocar esse id)
    e.target.closest('[data-afb-go-checkout]') ||                    // se você preferir usar data-attr
    e.target.closest('a[href="/checkout"], a[href^="/checkout?"], a[href*="/checkouts"]') || // links nativos
    e.target.closest('button[data-go="checkout"], button.afb-go-checkout'); // fallbacks

  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();
  if (e.stopImmediatePropagation) e.stopImmediatePropagation();

  window.AFB_goCheckout();
}, true);


// =====================================
// AFB — DETECTA BRINDE NA PÁGINA DO PRODUTO (PDP)
// =====================================
function AFB_isBrindePDP(){
  // 1) marcador por classe (ideal se você controlar no template)
  if (document.body && document.body.classList.contains('product-oculto')) {
    return true;
  }

  // 2) fallback por preço zero no DOM
  var priceEl =
    document.querySelector('[data-price]') ||
    document.querySelector('.price, .product-price, .price-new');

  if (priceEl) {
    var txt = priceEl.textContent || '';
    if (/0[,\.]00|R\$ ?0/i.test(txt)) return true;
  }

  return false;
}

  // =====================================
  // AFB — DETECTA FUNKO NA PÁGINA DO PRODUTO (PDP)
  // =====================================
  function AFB_isFunkoPDP(){
    // marcador opcional seu
    if (document.querySelector(".funko-cta")) return true;

    // vendor link padrão do tema
    var vendorLink = document.querySelector('.manufacture-product a[href*="/collections/vendors"]');
    if (vendorLink && /funko/i.test(vendorLink.textContent || "")) return true;

    // fallback: alguns temas imprimem vendor em texto
    var vendorBox =
      document.querySelector('.manufacture-product') ||
      document.querySelector('[itemprop="brand"]') ||
      document.querySelector('.product-vendor, .product__vendor');
    if (vendorBox && /funko/i.test(vendorBox.textContent || "")) return true;

    return false;
  }

  function AFB_getPDPQty(){
    var el =
      document.querySelector('#form_buy input[name="quantity"]') ||
      document.querySelector('#form_buy_sticky input[name="quantity"]') ||
      document.querySelector('form[action^="/cart/add"] input[name="quantity"]') ||
      document.querySelector('input[name="quantity"]') ||
      document.getElementById('input-quantity') ||
      document.getElementById('Quantity');

    var n = el ? parseInt(el.value, 10) : 1;
    return (isFinite(n) && n > 0) ? n : 1;
  }

  function AFB_funkoMinQty(){
    return 5; // seu mínimo
  }

  // Mensagem inline pro "Compre Já" em Funko (qty < 5) — sem optional chaining
  function AFB_showFunkoBuyNowInline(){
    var min = AFB_funkoMinQty();
    var q = AFB_getPDPQty();
    var missing = Math.max(0, min - q);

    var btn = document.querySelector('#button-cart-buy');
    var wrap = (btn && btn.parentNode) ? btn.parentNode : (document.querySelector('#form_buy') || document.body);

    var box = wrap.querySelector(".afbFunkoInlineMsg");
    if (!box) {
      box = document.createElement("div");
      box.className = "afbFunkoInlineMsg";
      wrap.appendChild(box);
    }

    box.innerHTML =
      "<div class='afb-funko-msg'>" +
        "<div class='afb-funko-ic' aria-hidden='true'>!</div>" +
        "<div class='afb-funko-body'>" +
          "<div class='afb-funko-toprow'>" +
            "<div class='afb-funko-title'>Ops! Vendemos o mínimo de 5 peças 👀</div>" +
          "</div>" +
          "<div class='afb-funko-main'>" +
            "Para usar <strong>Compre Já</strong>, selecione <strong>" + min + "</strong> unidades " +
            "<span class='afb-funko-sub'>(do mesmo modelo)</span>." +
            "<div class='afb-funko-counter'>" +
              "<span class='afb-funko-missing'>Faltam <strong>" + missing + "</strong> unidade(s).</span>" +
            "</div>" +
          "</div>" +
        "</div>" +
      "</div>";
  }

  function AFB_clearFunkoBuyNowInline(){
    var btn = document.querySelector('#button-cart-buy');
    var wrap = (btn && btn.parentNode) ? btn.parentNode : (document.querySelector('#form_buy') || null);
    var box = wrap ? wrap.querySelector(".afbFunkoInlineMsg") : null;
    if (box) box.remove();
  }


  // product page add to cart
  $('#button-cart').on('click', function(e) {
    e.preventDefault();
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: $('#form_buy').serialize(),
      dataType: 'json',
      beforeSend: function() {
        $('#button-cart').button('loading');
      },
      complete: function() {
        $('#button-cart').button('reset');
      },
      success: function(json) {
        var i;

        $('.alert, .text-danger').remove();
        $('.form-group').removeClass('has-error');

        if (json['error']) {
          if (json['error']['option']) {
            for (i in json['error']['option']) {
              var element = $('#input-option' + i.replace('_', '-'));
              if (element.parent().hasClass('input-group')) {
                element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              } else {
                element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              }
            }
          }
          if (json['error']['recurring']) {
            $('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
          }
          $('.text-danger').parent().addClass('has-error');
        }

        // ✅ substitui toastr
        AFB_AddToCartToast.show({
          title: "Parabéns! Seu item foi adicionado.",
          sub: "Clique em Finalizar compra quando quiser ✨",
          dur: 4200
        });

        var prevCount = AFB_readCartCount();
        AFB_waitCartUpdate(prevCount, 1500).then(function(cart){
          try{ load(cart); }catch(e){}
          try{ if (window.AFB_FUNKO_MIN && typeof window.AFB_FUNKO_MIN.recheck === 'function') window.AFB_FUNKO_MIN.recheck(); }catch(e2){}
        }).catch(function(){});

        $('html, body').animate({ scrollTop: 0 }, 'slow');
      },
      error: function(xhr, ajaxOptions, thrownError) {
        if(xhr.status == 422 ) {
          toastr.warning("Variante do item já adicionada ao carrinho.");
        } else {
          alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      }
    });
  });

  $('#button-cart-sticky').on('click', function(e) {
    e.preventDefault();
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: $('#form_buy_sticky').serialize(),
      dataType: 'json',
      beforeSend: function() {
        $('#button-cart-sticky').button('loading');
      },
      complete: function() {
        $('#button-cart-sticky').button('reset');
      },
      success: function(json) {
        var i;

        $('.alert, .text-danger').remove();
        $('.form-group').removeClass('has-error');

        if (json['error']) {
          if (json['error']['option']) {
            for (i in json['error']['option']) {
              var element = $('#input-option' + i.replace('_', '-'));
              if (element.parent().hasClass('input-group')) {
                element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              } else {
                element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              }
            }
          }
          if (json['error']['recurring']) {
            $('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
          }
          $('.text-danger').parent().addClass('has-error');
        }

        // ✅ substitui toastr
        AFB_AddToCartToast.show({
          title: "Parabéns! Seu item foi adicionado.",
          sub: "Seu carrinho já está pronto ✅",
          dur: 4200
        });

        var prevCount = AFB_readCartCount();
        AFB_waitCartUpdate(prevCount, 1500).then(function(cart){
          try{ load(cart); }catch(e){}
          try{ if (window.AFB_FUNKO_MIN && typeof window.AFB_FUNKO_MIN.recheck === 'function') window.AFB_FUNKO_MIN.recheck(); }catch(e2){}
        }).catch(function(){});

        $('html, body').animate({ scrollTop: 0 }, 'slow');
      },
      error: function(xhr, ajaxOptions, thrownError) {
        if(xhr.status == 422 ) {
          toastr.warning("Variante do item já adicionada ao carrinho.");
        } else {
          alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      }
    });
  });

  // ✅ BUY NOW com bloqueio Funko < 5 + marca sessão "voltando do checkout"
  $('#button-cart-buy').on('click', function(e) {
    e.preventDefault();

    try{
      if (AFB_isFunkoPDP()) {
        var min = AFB_funkoMinQty();
        var q = AFB_getPDPQty();
        if (q < min) {
          AFB_showFunkoBuyNowInline();
          return;
        } else {
          AFB_clearFunkoBuyNowInline();
        }
      }
    }catch(err){}

    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: $('#form_buy').serialize(),
      dataType: 'json',
      beforeSend: function() {
        $('#button-cart-buy').button('loading');
      },
      complete: function() {
        $('#button-cart-buy').button('reset');
      },
      success: function(json) {
        var i;

        $('.alert, .text-danger').remove();
        $('.form-group').removeClass('has-error');

        if (json['error']) {
          if (json['error']['option']) {
            for (i in json['error']['option']) {
              var element = $('#input-option' + i.replace('_', '-'));
              if (element.parent().hasClass('input-group')) {
                element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              } else {
                element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              }
            }
          }
          if (json['error']['recurring']) {
            $('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
          }
          $('.text-danger').parent().addClass('has-error');
        }

        // (buy now) vai pro checkout
        var prevCount = AFB_readCartCount();
        AFB_waitCartUpdate(prevCount, 1500).then(function(cart){
          try{ sessionStorage.setItem("AFB_FROM_CHECKOUT", "1"); }catch(e){}
          window.AFB_goCheckout();
        }).catch(function(){
          try{ sessionStorage.setItem("AFB_FROM_CHECKOUT", "1"); }catch(e){}
          window.AFB_goCheckout();
        });
      },
      error: function(xhr, ajaxOptions, thrownError) {
        if(xhr.status == 422 ) {
          toastr.warning("Variante do item já adicionada ao carrinho.");
        } else {
          alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      }
    });
  });

  //stickyMenu();
  // ✅ PATCH #3 — headerSpace só no desktop + evita duplicar
  var sticky_menu = parseInt($('#sticky-menu').attr('data-sticky'), 10) || 0;

  if (sticky_menu === 1 && window.innerWidth > 991){
    var headerSpaceH = 0;

    if ($(".common-home").length == 0){
      if ($(".hd3").length == 0) {
        headerSpaceH = $('header .header-inner').outerHeight(true);
      }
    } else {
      headerSpaceH = $('header').outerHeight(true) + $('header').offset().top;
    }

    if (!$('.headerSpace').length){
      $('header').before('<div class="headerSpace unvisible" style="height:'+headerSpaceH+'px;"></div>');
    }
  }

  // Scroll
  var currentP = 0;
  var stickyOffset1 = 0;
  var stickyOffset = 0;
  stickyOffset = $('header').offset().top;
  stickyOffset += $('header').outerHeight();
  stickyOffset += 30;

  if (!isEmpty($('#product-product'))) {
    stickyOffset1 = $('#form_buy').offset().top;
    stickyOffset1 += $('#form_buy').outerHeight();
  }

  $(window).scroll(function(){
    var headerH = $('header').height();
    var scrollP = $(window).scrollTop();
    var winInnW = window.innerWidth;

    if(scrollP != currentP){
      //Sticky header
      if( winInnW > 991 ){
        if (sticky_menu==1){
          if(scrollP >= stickyOffset){
            $('.fix').addClass('fix-header');
            $('.headerSpace').removeClass('unvisible');
            if (($(".hd3").length == 0 ) || ($(".hd4").length == 0)) {
              if (($(".bottom-menu").length == 0)) {
                $('.headerSpace').addClass('show');
              }
            }
          } else {
            $('.fix').removeClass('fix-header');
            $('.headerSpace').addClass('unvisible');
            if (($(".hd3").length == 0 ) || ($(".hd4").length == 0)) {
              if (($(".bottom-menu").length == 0)) {
                $('.headerSpace').removeClass('show');
              }
            }
          }
        }
      }

      if (!isEmpty($('#product-product'))) {
        if(scrollP >= stickyOffset1){
          $('.form_buy_sticky').addClass('fix-header2');
          $('.form_buy_sticky').addClass('fix-header1');
          $('html').css('padding-bottom','64px');
        } else {
          $('.form_buy_sticky').removeClass('fix-header1');
          $('.form_buy_sticky').removeClass('fix-header2');
          $('html').css('padding-bottom','0px');
        }
      }
      currentP = $(window).scrollTop();
    }
  });

  if (!isEmpty($('#product')))  { $('#product .option-container').addClass('has-option'); }
  if (!isEmpty($('#product2'))) { $('#product2 .option-container').addClass('has-option'); }

  // move breadcrumbs
  var breadcrumb = $('ul.breadcrumb');
  var breadcrumbs_container = $('.breadcrumbs .container');
  breadcrumb.appendTo(breadcrumbs_container);

  // Highlight any found errors
  $('.text-danger').each(function() {
    var element = $(this).parent().parent();
    if (element.hasClass('form-group')) {
      element.addClass('has-error');
    }
  });

  /* Search */
  $('#search input[name=\'q\']').parent().find('button').on('click', function() {
    var url = '/search';
    var value = $('#search input[name=\'q\']').val();
    if(value == "Search all products..." || value ==""){
      $('#search .search-content input[name=\'q\']').focus();
      return false;
    } else {
      url += '?type=product&q=' + encodeURIComponent(value);
    }
    location = url;
  });

  $('#search input[name=\'q\']').on('keydown', function(e) {
    if (e.keyCode == 13) {
      $('header #search input[name=\'q\']').parent().find('button').trigger('click');
    }
  });

  // Menu
  $('#menu .dropdown-menu').each(function() {
    var menu = $('#menu').offset();
    var dropdown = $(this).parent().offset();
    var i = (dropdown.left + $(this).outerWidth()) - (menu.left + $('#menu').outerWidth());
    if (i > 0) {
      $(this).css('margin-left', '-' + (i + 10) + 'px');
    }
  });

  if (localStorage.getItem('display') == null) {
    $('#list-view').trigger('click');
  } else if (localStorage.getItem('display') == 'grid') {
    $('#grid-view').trigger('click');
  } else {
    $('#list-view').trigger('click');
  }

  // Checkout
  $(document).on('keydown', '#collapse-checkout-option input[name=\'email\'], #collapse-checkout-option input[name=\'password\']', function(e) {
    if (e.keyCode == 13) {
      $('#collapse-checkout-option #button-login').trigger('click');
    }
  });

  // tooltips on hover
  $('[data-toggle=\'tooltip\']').tooltip({container: 'body'});

  // Makes tooltips work on ajax generated content
  $(document).ajaxStop(function() {
    $('[data-toggle=\'tooltip\']').tooltip({container: 'body'});
  });

}); // end ready


// =========================================================
// Cart add/remove (FIX DEFINITIVO)
// - add: /cart/add.js
// - remove: /cart/change.js usando item.key (line item key)
// =========================================================
var cart = {
  'add': function(product_id, quantity, redirect) {
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: 'id=' + product_id + '&quantity=' + (typeof(quantity) != 'undefined' ? quantity : 1),
      dataType: 'json',
      beforeSend: function() {
        if (redirect) {
          $('.button-cart.button').button('loading');
        } else {
          $('.button-cart > .button').button('loading');
        }
      },
      complete: function() {
        if (redirect) {
          $('.button-cart.button').button('reset');
        } else {
          $('.button-cart > .button').button('reset');
        }
      },
      success: function(json) {
        $('.alert, .text-danger').remove();

        if (json['redirect']) location = json['redirect'];

        if (window.AFB_AddToCartToast) {
          AFB_AddToCartToast.show({
            title: "Parabéns! Seu item foi adicionado.",
            sub: (redirect ? "Indo pro checkout... 🚀" : "Quer finalizar agora? ✅"),
            dur: (redirect ? 2200 : 4200)
          });
        } else if (window.toastr) {
          toastr.success("Parabéns! Seu item foi adicionado.");
        }

        var prevCount = AFB_readCartCount();
        AFB_waitCartUpdate(prevCount, 1500).then(function(c){
          if (redirect) {
            try{ sessionStorage.setItem("AFB_FROM_CHECKOUT", "1"); }catch(e){}
            window.AFB_goCheckout();
          } else {
            load(c);
          }
        }).catch(function(){
          if (redirect) {
            try{ sessionStorage.setItem("AFB_FROM_CHECKOUT", "1"); }catch(e){}
            window.AFB_goCheckout();
          } else {
            // fallback leve (ainda tenta ao menos render)
            $.getJSON('/cart.js?ts=' + Date.now(), function(c2){ try{ load(c2); }catch(_){} });
          }
        });
      },
      error: function(xhr, ajaxOptions, thrownError) {
        if (xhr.status == 422) {
          toastr.warning("Variante do item já adicionada ao carrinho.");
        } else {
          alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      }
    });
  },

  'remove': function(lineItemKey) {
    $.ajax({
      url: '/cart/change.js',
      type: 'post',
      data: 'id=' + encodeURIComponent(lineItemKey) + '&quantity=0',
      dataType: 'json',
      success: function(cartData) {

        // se estiver na página /cart, recarrega pra manter tudo consistente
        if (location.pathname === '/cart') {
          location.reload();
          return;
        }

        load(cartData);

        // ✅ evita o “reset” ressuscitar número antigo
        var $btn = $('#cart > button');
        if ($btn.length) {
          $btn.data('resetText', $btn.html());
          $btn.button('reset');
        }
      },
      error: function(xhr) {
        alert(xhr.responseText);
      }
    });
  }
};

/* =========================================================
AFB — FIX MINI-CART FANTASMA (bfcache) + remove compatível
- Re-sincroniza mini-cart ao voltar do checkout (sem reload)
- cart.remove aceita: key OU variantId OU line(1,2,3...)
========================================================= */
(function(){
  if (window.__AFB_MINICART_FIX_READY) return;
  window.__AFB_MINICART_FIX_READY = true;

  var SS_FROM_CHECKOUT = "AFB_FROM_CHECKOUT";

  function markFromCheckout(){
    try{ sessionStorage.setItem(SS_FROM_CHECKOUT, "1"); }catch(e){}
  }
  function cameFromCheckout(){
    try{ return sessionStorage.getItem(SS_FROM_CHECKOUT) === "1"; }catch(e){ return false; }
  }
  function clearFromCheckout(){
    try{ sessionStorage.removeItem(SS_FROM_CHECKOUT); }catch(e){}
  }

  function isBackForwardNav(){
    try{
      if (performance && performance.getEntriesByType) {
        var nav = performance.getEntriesByType('navigation')[0];
        if (nav && nav.type) return nav.type === 'back_forward';
      }
    }catch(e){}
    return false;
  }

  function isCheckoutPath(){
    try{
      var p = (location && location.pathname) ? String(location.pathname) : "";
      return /\/checkouts?\b/i.test(p);
    }catch(e){}
    return false;
  }

  function syncMiniCart(){
    if (isCheckoutPath()) return;
    if (typeof jQuery === "undefined") return;

    // se nem existe mini-cart no DOM, não faz nada
    if (!document.querySelector('#cart .dropdown-menu')) return;

    jQuery.getJSON("/cart.js?ts=" + Date.now(), function(c){
      if (typeof load === "function") {
        load(c);
      }
    });
  }

  // marca quando o usuário vai pro checkout (serve pro pageshow)
  document.addEventListener("click", function(ev){
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href*="/checkout"], a[href*="/checkouts/"]') : null;
    if (a) markFromCheckout();
  }, true);

  // marca quando vai pro checkout via submit (caso exista)
  document.addEventListener("submit", function(ev){
    try{
      var f = ev.target;
      var act = (f && f.action) ? String(f.action) : "";
      if (/\/checkouts?\b/i.test(act)) markFromCheckout();
    }catch(e){}
  }, true);

  // ao voltar (bfcache/back-forward), re-sincroniza o mini-cart
  window.addEventListener("pageshow", function(e){
    var backLike = (e && e.persisted) || isBackForwardNav() || cameFromCheckout();
    if (backLike){
      clearFromCheckout();
      syncMiniCart();
    }
  }, true);

  // ao abrir o mini-cart, também garante que está atualizado (throttle)
  if (window.jQuery) {
    jQuery(function($){
      var t = 0;
      $(document).on("click mouseenter", "#cart, #cart > button, #cart button", function(){
        var now = Date.now();
        if (now - t < 600) return;
        t = now;
        syncMiniCart();
      });
    });
  }

  // --- BLINDAGEM: cart.remove aceita key / variantId / line ---
  if (!window.cart || typeof window.cart.remove !== "function") return;

  var _rm = window.cart.remove;

  window.cart.remove = function(idOrKey){
    var s = String(idOrKey || "").trim();
    if (!s) return;

    // key geralmente contém ":" (ex: 1234567890:abcd...)
    if (s.indexOf(":") !== -1) {
      return _rm(s);
    }

    if (typeof jQuery === "undefined") {
      return _rm(s); // fallback
    }

    jQuery.getJSON("/cart.js?ts=" + Date.now(), function(c){
      var items = (c && c.items) ? c.items : [];

      // 1) se veio "line" (1,2,3...), converte pra key real
      if (/^\d{1,3}$/.test(s) && items.length) {
        var idx = parseInt(s, 10) - 1;
        if (idx >= 0 && idx < items.length && items[idx] && items[idx].key) {
          return _rm(items[idx].key);
        }
      }

      // 2) se veio variantId (HTML antigo), converte para key
      var key = "";
      for (var i=0;i<items.length;i++){
        if (String(items[i].id) === s){
          key = items[i].key;
          break;
        }
      }

      if (key) {
        _rm(key); // ✅ remove correto
      } else {
        // ✅ era fantasma (não existe no cart real) => só re-render (se load já existe)
        if (typeof load === "function") load(c);
      }
    });
  };

})();


// =========================================================
// MINI CART RENDER (FIX ícone X + remove correto)
// =========================================================
function load(cartData){
  $('#cart .dropdown-menu > li:first-child .table > tbody > tr').remove();

  $.each(cartData.items, function (index, item) {

    // ✅ remove por key (line item key)
    var cartRemove = "onclick=\"cart.remove('" + item.key + "')\"";

    // ✅ preço correto (centavos)
    var unitPriceHtml = "<span class='money'>" + Shopify.formatMoney(item.price, moneyFormat) + "</span>";

    // ✅ fallback de imagem (se vier null)
    var imgSrc = item.image ? item.image : "";

    var row =
      "<tr>" +
        "<td class='text-center'>" +
          "<a href='" + item.url + "' title='" + item.title + "'>" +
            "<img class='cart-image' src='" + imgSrc + "' alt='" + item.title + "' title='" + item.title + "'>" +
          "</a>" +
        "</td>" +
        "<td class='text-left info-item'>" +
          "<a class='cart-name' href='" + item.url + "'>" + item.title + "</a>" +
          "<p class='cart-quantity'>" + item.quantity + " &times;</p>" +
          "<p class='cart-price'>" + unitPriceHtml + "</p>" +
        "</td>" +
        "<td class='text-center cart-close'>" +
          "<button type='button' " + cartRemove + " title='Remover' class='btn btn-danger btn-xs'>" +
            "<span aria-hidden='true' style='font-size:24px;line-height:1'>×</span>" +
          "</button>" +
        "</td>" +
      "</tr>";

    $('#cart .dropdown-menu > li:first-child .table > tbody').append(row);
  });

  if (cartData.item_count < 1) {
    // ✅ vazio dentro da tabela (HTML válido)
    $('#cart .dropdown-menu > li:first-child .table > tbody')
      .append(
        "<tr class='afb-cart-empty-row'>" +
          "<td colspan='3' class='text-center cart-empty'>Seu carrinho está vazio!</td>" +
        "</tr>"
      );

    $('#cart .dropdown-menu li:not(:first-child):last-child').removeClass('show').addClass('hide');
  } else {
    $('#cart .dropdown-menu .afb-cart-empty-row').remove();
    $('#cart .dropdown-menu li:not(:first-child):last-child').removeClass('hide').addClass('show');
  }

  $('#cart > button #cart-total').html(cartData.item_count);

  $('#cart > button .total-price').html(
    "<span class='money'>" + Shopify.formatMoney(cartData.total_price, moneyFormat) + "<i class='fas fa-chevron-down'></i></span>"
  );

  $('#cart-subtotal').html(
    "<span class='money'>" + Shopify.formatMoney(cartData.total_price, moneyFormat) + "</span>"
  );

  
  if (Currency.cookie.read() != null) {
    Currency.convertAll(shopCurrency, Currency.cookie.read());
  }
  
}


/* Agree to Terms */
$(document).delegate('.agree', 'click', function(e) {
  e.preventDefault();
  $('#modal-agree').remove();

  var element = this;

  $.ajax({
    url: $(element).attr('href'),
    type: 'get',
    dataType: 'html',
    success: function(data) {
      var html  = '<div id="modal-agree" class="modal">';
      html += '  <div class="modal-dialog">';
      html += '    <div class="modal-content">';
      html += '      <div class="modal-header">';
      html += '        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>';
      html += '        <h4 class="modal-title">' + $(element).text() + '</h4>';
      html += '      </div>';
      html += '      <div class="modal-body">' + data + '</div>';
      html += '    </div>';
      html += '  </div>';
      html += '</div>';

      $('body').append(html);
      $('#modal-agree').modal('show');
    }
  });
});


// Autocomplete */
(function($) {
  $.fn.autocomplete = function(option) {
    return this.each(function() {
      this.timer = null;
      this.items = new Array();

      $.extend(this, option);
      $(this).attr('autocomplete', 'off');

      // Focus
      $(this).on('focus', function() {
        this.request();
      });

      // Blur
      $(this).on('blur', function() {
        setTimeout(function(object) {
          object.hide();
        }, 200, this);
      });

      // Keydown
      $(this).on('keydown', function(event) {
        switch(event.keyCode) {
          case 27: this.hide(); break; // escape
          default: this.request(); break;
        }
      });

      // Click
      this.click = function(event) {
        event.preventDefault();
        var value = $(event.target).parent().attr('data-value');
        if (value && this.items[value]) {
          this.select(this.items[value]);
        }
      };

      // Show
      this.show = function() {
        var pos = $(this).position();
        $(this).siblings('ul.dropdown-menu').css({
          top: pos.top + $(this).outerHeight(),
          left: pos.left
        });
        $(this).siblings('ul.dropdown-menu').show();
      };

      // Hide
      this.hide = function() {
        $(this).siblings('ul.dropdown-menu').hide();
      };

      // Request
      this.request = function() {
        clearTimeout(this.timer);
        this.timer = setTimeout(function(object) {
          object.source($(object).val(), $.proxy(object.response, object));
        }, 200, this);
      };

      // Response
      this.response = function(json) {
        var html = '';

        if (json.length) {
          for (var i = 0; i < json.length; i++) {
            this.items[json[i]['value']] = json[i];
          }

          for (var i2 = 0; i2 < json.length; i2++) {
            if (!json[i2]['category']) {
              html += '<li data-value="' + json[i2]['value'] + '"><a href="#">' + json[i2]['label'] + '</a></li>';
            }
          }

          // Get all the ones with a categories
          var category = new Array();
          for (var i3 = 0; i3 < json.length; i3++) {
            if (json[i3]['category']) {
              if (!category[json[i3]['category']]) {
                category[json[i3]['category']] = new Array();
                category[json[i3]['category']]['name'] = json[i3]['category'];
                category[json[i3]['category']]['item'] = new Array();
              }
              category[json[i3]['category']]['item'].push(json[i3]);
            }
          }

          for (var k in category) {
            html += '<li class="dropdown-header">' + category[k]['name'] + '</li>';
            for (var j = 0; j < category[k]['item'].length; j++) {
              html += '<li data-value="' + category[k]['item'][j]['value'] + '"><a href="#">&nbsp;&nbsp;&nbsp;' + category[k]['item'][j]['label'] + '</a></li>';
            }
          }
        }

        if (html) { this.show(); } else { this.hide(); }
        $(this).siblings('ul.dropdown-menu').html(html);
      };

      $(this).after('<ul class="dropdown-menu"></ul>');
      $(this).siblings('ul.dropdown-menu').delegate('a', 'click', $.proxy(this.click, this));
    });
  }
})(window.jQuery);
(function(){
  if (window.__AFB_FORCE_YEVER_NAV) return;
  window.__AFB_FORCE_YEVER_NAV = true;

  function isNativeCheckoutUrl(u){
    try{ return /\/checkouts?\b/i.test(String(u||"")); }catch(e){ return false; }
  }

  // Intercepta navegacao via location.assign / replace (muitos scripts usam isso)
  try{
    var _assign  = window.location.assign.bind(window.location);
    var _replace = window.location.replace.bind(window.location);

    window.location.assign = function(url){
      if (isNativeCheckoutUrl(url) && typeof window.AFB_goCheckout === "function"){
        return window.AFB_goCheckout();
      }
      return _assign(url);
    };

    window.location.replace = function(url){
      if (isNativeCheckoutUrl(url) && typeof window.AFB_goCheckout === "function"){
        return window.AFB_goCheckout();
      }
      return _replace(url);
    };
  }catch(e){}

  // Intercepta QUALQUER clique que tentaria /checkout
  document.addEventListener('click', function(e){
    var el = e.target && e.target.closest ? e.target.closest(
      'a[href="/checkout"], a[href^="/checkout?"], a[href*="/checkouts"], button[name="checkout"], [data-go="checkout"], [data-checkout]'
    ) : null;
    if (!el) return;

    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    if (typeof window.AFB_goCheckout === "function") window.AFB_goCheckout();
  }, true);
})();